define([
	'marketplace/models/mp_api_model',
	'lodash.debounce',
	'marketplace/components/error_tracker'
], function (MPAPIModel, debounce, ErrorTracker) {
	var AddressModel = MPAPIModel.extend({
		defaults: {
			'to': '',
			'first_name': '',
			'last_name': '',
			'country': 'US'
		},
		urlRoot: '/api/addresses/',
		state: {
			guestCheckout: false,
			appProcessing: false,
		},

		initialize: function() {
			this.saveIfComplete = debounce(this._saveIfComplete.bind(this), 250);

			this.on('change:firstName', this.updateTo, this);
			this.on('change:lastName', this.updateTo, this);

			this.on('change:to', this.saveIfComplete, this);
			this.on('change:street', this.saveIfComplete, this);
			this.on('change:state', this.saveIfComplete, this);
			this.on('change:country', this.saveIfComplete, this);
			this.on('change:zipCode', this.saveIfComplete, this);
			this.on('change:company', this.saveIfComplete, this);
			this.on('change:phoneNumber', this.saveIfComplete, this);
		},

		setGuestCheckout: function() {
			this.state.guestCheckout = true;
		},

		setAppProcessing: function(processing) {
			processing = processing !== false; // default to true
			this.state.appProcessing = processing;
		},

		isDirty: function() {
			// This tells dep_model not to save
			if (this.state.appProcessing) {
				return false;
			}
			// fallback to bb
			return this.hasChanged();
		},

		_saveIfComplete: function() {
			var plzSave = false;

			// required zip and state for US addresses
			if (this.get('country') === 'US') {
				if (this.get('state') && this.get('zipCode')) {
					plzSave = true;
				}
			}

			// save non-US addresses no matter what, maybe optimize
			else {
				plzSave = true;
			}

			// If we are checking out as a guest we can't save address info as we go,
			// since we won't have an account until the order is submitted.
			if (plzSave && !this.state.guestCheckout && !this.state.appProcessing) {
				this.save().fail(res => {
					if(res.status === 401) {
						ErrorTracker.captureMessageWithExtra('MPXO: Checkout error - 401 saving customer address', 'error', res.responseJSON);
					}
				});
			}
		},

		updateTo: function() {
			var first = this.get('firstName') || "";
			var last = this.get('lastName') || "";
			var to = `${first} ${last}`.trim() || "Current Resident";
			if (!to.includes(' ')) {
				to += ' .';
			}

			this.set('to', to);
		},

		isValid: function() {
			var fullName = this.get('to');
			return fullName && fullName.trim().split(' ').length > 1;
		},

		parse: function(response, options) {
			var parsed = MPAPIModel.prototype.parse.apply(response, arguments);

			var addr = parsed.address;
			addr.id = parsed.id;
			addr.defaultShip = parsed.defaultShip;
			return addr;
		}
	});

	return AddressModel;
});
